// extracted by mini-css-extract-plugin
module.exports = {"actions":"styles_actions__2YwVA","col":"styles_col__1a64B"};